import type { Slicer } from '@swf/core/store';
import type { PageData } from '@swf/core/types/Poker';

export default (slice: Slicer<PageData>) => ({
  get() {
    return slice;
  },
  activeGames() {
    return slice((state) => state.games.activeGameIds);
  },
  clubs() {
    return slice((state) => state.clubs);
  },
  tournaments() {
    return slice((state) => state.games.tourns);
  },
  tables() {
    return slice((state) => state.games.tables);
  },
  recentTourns() {
    return slice((state) => state.games.recentTourns);
  },
  selectedGames() {
    return slice((state) => state.games.selectedGameIds);
  },
  loading() {
    return slice((state) => state.loading);
  }
});
